import { createEntityAdapter } from '@reduxjs/toolkit';

const zoneHostnamesAdapter = createEntityAdapter();

export default zoneHostnamesAdapter;
